import _ from 'lodash';

import analytics from 'scripts/lib/analytics';
import PerformExternalAction from 'models/perform_external_action';

export default class PerformAction {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, action }) {
    let actionName = '';
    const performExternalActionStore = this.context.stores.performExternalAction.get();
    if (performExternalActionStore) {
      actionName = _.get(performExternalActionStore.toJs(), 'action.name');
    }

    this.context.stores.performExternalAction.set(PerformExternalAction.create({ customerId, action }));
    this.context.stores.performExternalAction.setLoading();
    this.context.gateways.externalCustomerLookupActions.performAction(customerId, action);

    analytics.track('Action Performed', {
      actionName,
      customerId,
      conversationId: this.getCurrentConversationId(customerId),
    });
  }

  getCurrentConversationId(customerId) {
    let currentLocation = this.context.stores.currentLocation.get();
    return currentLocation.customerId === customerId ? currentLocation.currentConversationId : null;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/external_customer_lookup/perform_action.js